import React from 'react';
import Lectura from './lectura';
import Titulo from './Titulo';
import styled from 'styled-components';
import './App.css'; // Importa el archivo CSS
import Footer from './Footer';
import {Helmet} from "react-helmet";
import favicon from "./Imagenes/favicon.ico"


 

function App() {
  return (

    <div className="App">
    
    <>
       <Helmet>
          <meta charSet="utf-8" />
          <link rel="shortcut icon" href={favicon} type='image/x-icon'/>
          
          <title>Catálogo de cursos de formación didáctica y pedagógica para el proceso de admisión en educación media superior, ciclo escolar 2026-2027</title>
        </Helmet>
        <div className="svg-container">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path
                  fill="#e6d194"
                  fillOpacity="1"
                  d="M0,64L48,53.3C96,43,192,21,288,58.7C384,96,480,192,576,229.3C672,267,768,245,864,208C960,171,1056,117,1152,106.7C1248,96,1344,128,1392,144L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
                ></path>
              </svg>
            
            </div>

          <Titulo/>
          <H1>CATÁLOGO DE CURSOS DE FORMACIÓN DIDÁCTICA Y PEDAGÓGICA PARA EL PROCESO <br></br>DE ADMISIÓN EN EDUCACIÓN MEDIA SUPERIOR, <br></br>CICLO ESCOLAR 2026-2027</H1>
              <Lectura/>
            
              
              
        
              <Footer/>
    </>
    
    </div>
  );
}
export default App;

const H1 = styled.h1`
    color: rgb(2550,255,255);
    margin: 1%;
    top: 0; /* Coloca el SVG en la parte superior de la pantalla */
    left: 0; /* Coloca el SVG en la parte izquierda de la pantalla */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem; /* Disminuir el tamaño de la fuente en un 20% (80% del tamaño original) */
    width: 100%; /* Ocupa todo el ancho disponible */
    text-align: center; /* Centra el texto horizontalmente */
       @media (max-width: 768px) {
        width: 91%; /* Ocupa todo el ancho del contenedor en pantallas pequeñas */
        
       
    }
`;
